<template>
  <div class="toggle-master" :class="{'disable-toggle': disableToggle}">
    <label class="master" @click="handleToggle">{{ label }}</label>
    <label class="switch" tabindex="0" @click="handleToggle" @keyup.enter="handleToggle" :style="{float:`${floatRight ? 'right' : 'none'}`, display: `${floatRight ? 'unset' : 'inline-block'}`}">
      <div class="slider round" :class="toggleClass">
        {{ toggleDisplayText }}
      </div>
    </label>
    <div class="toggle-view" v-if="value && !noContent">
      <slot />
    </div>
  </div>
</template>

<style lang="less" scoped>
@toggle-height: 25px;
@toggle-width: 56px;

div.toggle-master {
  width: 100%;
  &.disable-toggle {
    opacity: 0.4;
  }
  label.master {
    display: inline-block;
    margin: 0;
    font-size: 1em;
  }

  label.switch {
    margin: 0 0 0 10px;
    position: relative;
    vertical-align: middle;
    width: @toggle-width;
    height: @toggle-height;
    line-height: 1.5em;

    div.slider {
      cursor: pointer;
      background-color: #777;
      position: absolute;
      color: white;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      transition: 0.4s;
      padding: 0 10px;
      text-align: right;
      padding-top: 1px;

      &:focus {
        box-shadow: 0 0 1px #1dae66;
      }

      &.middle-state {
        &:before {
          transform: translateX(15px);
        }
        background-color: #bbb;
      }
      &.checked {
        &:before {
          transform: translateX(30px);
        }
        background-color: #1dae66;
        text-align: left;
      }

      &.round {
        border-radius: 50px;

        &:before {
          border-radius: 50%;
        }
      }

      &:before {
        position: absolute;
        content: "";
        height: 17px;
        width: 17px;
        left: 4px;
        bottom: 4px;
        background-color: #ffffff;
        transition: 0.3s;
      }
    }
  }

  div.toggle-view {
    overflow: hidden;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    margin-top: 1em;
    padding-top: 1em;
  }
}
</style>
<script>
export default {
  props: {
    label: {
      type: String
    },
    value: {
      type: Boolean
    },
    noContent: {
      type: Boolean,
      default: false
    },
    floatRight: {
      required: false,
      default: true
    },
    disableToggle: {
      required: false,
      default: false
    }
  },
  methods: {
    handleToggle() {
      if (!this.disableToggle) {
        this.$emit("input", !this.value);
      }
    }
  },
  computed: {
    toggleStatus() {
      if (this.value) {
        return "checked";
      } else if (this.value !== false) {
        return "middle-state";
      }
      return "unchecked";
    },
    toggleDisplayText() {
      if (this.toggleStatus == "checked") {
        return this.$t("message.on");
      } else if (this.toggleStatus == "unchecked") {
        return this.$t("message.off");
      } else if (this.toggleStatus == "middle-state") {
        return "";
      }
    },
    toggleClass() {
      return this.toggleStatus;
    }
  }
};
</script>
